import * as React from 'react';
import * as cssDefs from './linkCssDefs';
// eslint-disable-next-line no-restricted-imports
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@material-ui/core';
import Anchor, { Props as AnchorProps } from 'components/Anchor';

export type LinkSize = 'small' | 'medium' | 'large' | 'jumbo';
export type LinkColor = 'inherit' | 'primary';
export type LinkUnderline = 'none' | 'always' | 'hover';

export interface LinkProps
  extends Omit<MuiLinkProps, 'color'>,
    Pick<AnchorProps, 'allowDataProtocolUrl'> {
  color?: LinkColor;
  size?: LinkSize;
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  disabled?: boolean;
  underline?: LinkUnderline;
}

const Link: React.FunctionComponent<LinkProps> = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      color = 'primary',
      size,
      children,
      iconStart,
      iconEnd,
      disabled,
      underline = 'always',
      href,
      ...rest
    },
    ref
  ) => (
    <MuiLink
      aria-disabled={disabled || undefined}
      ref={ref}
      href={disabled ? undefined : href}
      component={Anchor}
      underline={underline}
      color={color}
      css={[
        cssDefs.sharedBaseStyles,
        (iconStart || iconEnd) && cssDefs.adornedLinkOnlyBaseStyles,
        color === 'primary' && cssDefs.colorStyles,
        cssDefs.size(size),
        disabled && cssDefs.disabledStyles,
      ]}
      {...rest}
    >
      {iconStart && <span css={cssDefs.icon(size)}>{iconStart}</span>}
      {children}
      {iconEnd && <span css={cssDefs.icon(size)}>{iconEnd}</span>}
    </MuiLink>
  )
);

export default Link;
